import { render, staticRenderFns } from "./BlocoDadosCertificacao.vue?vue&type=template&id=259154a2&scoped=true"
import script from "./BlocoDadosCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCertificacao.vue?vue&type=style&index=0&id=259154a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259154a2",
  null
  
)

export default component.exports